<template>
  <div class="header_box">
    <div class="header_tilte">
      <i class="iconfont iconcaidan" @click="open"></i>
      <img src="./home_logo2.png" alt="" v-if="!hdtitle">
      <h2>{{hdtitle}}</h2>
    </div>
    <div class="popup_c" v-show="show">
      <div class="popup_c_b">
        <div class="van_box">
          <i class="iconfont iconfork" @click="close"></i>
          <div class="header_a">
            <router-link active-class="active_a" :to="{path: '/home'}">首页</router-link>
            <!-- <a @click="toaso" :class="{active_a: $route.path == '/aso'}">ASO</a> -->
            <a @click="toasa">ASA</a>
            <a @click="toMetahands" :class="{active_a: $route.path == '/metahands'}">MetaHands</a>
            <!-- <router-link active-class="active_a" :to="{path: '/interaction'}" target="_blank">游戏SaaS </router-link> -->
            <router-link active-class="active_a" :to="{path: '/about_adjuz'}" target="_blank">关于巨掌</router-link>
            <router-link active-class="active_a" :to="{path: '/friend'}" target="_blank">合作伙伴</router-link>
            <router-link active-class="active_a" :to="{path: '/joinus'}" target="_blank">加入我们</router-link>
            <router-link active-class="active_a" :to="{path: '/contactus'}" target="_blank">联系我们</router-link>
          </div>
        </div>
      </div>
      <div class="van_box_right" @click="close"></div>
    </div>
    <!-- <van-popup v-model="show" position="left" :style="{ width: '50%' ,height: '100%'}">
      <div class="van_box">
        <i class="iconfont iconfork" @click="show = false"></i>
        <div class="header_a">
          <router-link active-class="active_a" :to="{path: '/home'}">首页</router-link>
          <a @click="toaso" :class="{active_a: $route.path == '/aso'}">ASO</a>
          <a @click="toasa">ASA</a>
          <router-link active-class="active_a" :to="{path: '/interaction'}" target="_blank">游戏SaaS </router-link>
          <router-link active-class="active_a" :to="{path: '/about_adjuz'}" target="_blank">关于巨掌</router-link>
          <router-link active-class="active_a" :to="{path: '/friend'}" target="_blank">合作伙伴</router-link>
          <router-link active-class="active_a" :to="{path: '/joinus'}" target="_blank">加入我们</router-link>
          <router-link active-class="active_a" :to="{path: '/contactus'}" target="_blank">联系我们</router-link>
        </div>
      </div>
    </van-popup> -->
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      show: false,
      isopen: false,
    };
  },
  props: {
    hdtitle: {
      type: null,
      default: "",
    },
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    toasa() {
      window.open("https://www.appasa.com/");
    },
    toaso() {
      this.$windowopen({ path: "/aso" });
    },
    toMetahands() {
      this.$windowopen({ path: "/metahands" });
    },
    open() {
      this.show = true;
      if ($(".video-player")) {
        $(".home-banner").css("display", "none");
      }
      $(".popup_c_b").animate({ left: 0 }, 300, "linear", () => {});
      $(".popup_c").animate({ opacity: 1 }, 300, "linear");
    },
    close() {
      $(".popup_c_b").animate({ left: "-200%" }, 500, "linear", () => {
        if ($(".video-player")) {
          $(".home-banner").css("display", "block");
        }
        this.show = false;
      });
      $(".popup_c").animate({ opacity: 0 }, 500, "linear");
    },
  },
};
</script>

<style lang="less" scoped>
.header_box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2005;
  height: 1rem;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(219, 229, 236, 0.75);
  .popup_c {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.7);
    .popup_c_b {
      position: absolute;
      left: -200%;
      width: 50%;
      top: 0;
      bottom: 0;
      z-index: 2004;
      background: #fff;
    }
  }
  .header_tilte {
    width: 100%;
    height: 100%;
    position: relative;
  }
  img {
    width: 1.9rem;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .iconcaidan {
    margin-left: 0.22rem;
    line-height: 1rem;
    color: #108ee9;
    font-size: 0.4rem;
  }
  h2 {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #333;
    font-size: 0.36rem;
    font-weight: bold;
  }
  .van_box {
    width: 100%;
    height: 100%;
    position: relative;
    .iconfork {
      color: #333;
      font-size: 0.5rem;
      position: absolute;
      left: 0.22rem;
      top: 0.22rem;
    }
    .header_a {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 1rem 0 0 1rem;
      a {
        color: #333;
        font-size: 0.32rem;
        line-height: 1rem;
        &.active_a {
          color: #108ee9;
        }
        &:active {
          color: #108ee9;
          text-decoration: underline;
        }
      }
    }
  }
  .van_box_right {
    position: absolute;
    left: 50%;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2004;
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/header.vue